import { Home, Phone, Mail, Edit2, Eye } from 'lucide-react';
import React from 'react'
import DataTable from 'react-data-table-component';

const customStyles = {
  header: {
    style: {
      minHeight: '56px',
    },
  },
  headRow: {
    style: {
      backgroundColor: '#0D3B3F',
      borderTopStyle: 'solid',
      borderTopWidth: '1px',
      borderTopColor: 'rgba(255,255,255,0.1)',
      borderRadius: '1.5rem 1.5rem 0 0',
      marginBottom: '8px',
    },
  },
  headCells: {
    style: {
      color: '#EAB308',
      fontSize: '10px',
      fontWeight: '900',
      textTransform: 'uppercase',
      letterSpacing: '0.2em',
      paddingLeft: '24px',
    },
  },
  cells: {
    style: {
      fontSize: '13px',
      color: '#0D3B3F',
      paddingLeft: '24px',
      fontWeight: '600',
    },
  },
  rows: {
    style: {
      minHeight: '72px',
      borderRadius: '1rem',
      backgroundColor: 'white',
      marginBottom: '8px',
      border: '1px solid #F3F4F6',
      '&:hover': {
        backgroundColor: '#F9FAFB',
        transform: 'scale-[1.01]',
        boxShadow: '0 10px 30px rgba(0,0,0,0.02)',
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
      }
    },
  },
  pagination: {
    style: {
      border: 'none',
      fontSize: '11px',
      fontWeight: '800',
      color: '#0D3B3F',
      textTransform: 'uppercase',
      letterSpacing: '0.1em',
      marginTop: '12px',
    },
  },
};

export default function SharesDataTable({ businesses, onEdit, onPreview }) {
  const columns = [
    {
      name: 'Restaurant Name',
      selector: row => row.name,
      sortable: true,
      cell: row => (
        <div className="flex flex-col py-2">
          <span className="font-bold text-premium-teal">{row.name}</span>
          <span className="text-[10px] text-gray-400 font-medium truncate max-w-[150px]">{row.uuid}</span>
        </div>
      )
    },
    {
      name: 'Contact Info',
      selector: row => row.phone,
      cell: row => (
        <div className="flex flex-col gap-1 py-1">
          <div className="flex items-center gap-2 text-xs">
            <Phone size={12} className="text-premium-gold/60" />
            <span>{row.phone}</span>
          </div>
          <div className="flex items-center gap-2 text-xs text-gray-400">
            <Mail size={12} className="text-premium-gold/60" />
            <span className="truncate max-w-[120px]">{row.email}</span>
          </div>
        </div>
      )
    },
    {
      name: 'Location',
      selector: row => row.address,
      cell: row => (
        <div className="flex items-center gap-2">
          <Home size={14} className="text-premium-gold/50" />
          <span className="text-xs italic text-gray-500 truncate max-w-[150px]">{row.address}</span>
        </div>
      )
    },
    {
      name: 'Status',
      selector: row => row.status,
      cell: row => (
        <span className={`px-3 py-1 rounded-full text-[9px] font-black uppercase tracking-widest border ${row.status === 'ACTIVE'
          ? 'bg-green-50 text-green-600 border-green-100'
          : 'bg-premium-teal/5 text-premium-teal border-premium-teal/10'
          }`}>
          {row.status || "PENDING"}
        </span>
      )
    },
    {
      name: 'Actions',
      cell: row => (
        <div className="flex items-center gap-1">
          <button
            onClick={() => onPreview(row)}
            className="p-2 hover:bg-premium-teal/10 rounded-lg text-premium-teal transition-colors"
            title="Preview Destination"
          >
            <Eye size={16} />
          </button>
          <button
            onClick={() => onEdit(row)}
            className="p-2 hover:bg-premium-gold/10 rounded-lg text-premium-gold transition-colors"
            title="Edit Hub"
          >
            <Edit2 size={16} />
          </button>
        </div>
      )
    }
  ];

  return (
    <div className="animate-fade-in-up">
      <DataTable
        columns={columns}
        data={businesses || []}
        pagination
        customStyles={customStyles}
        noHeader
      />
    </div>
  );
}
